import { Card } from 'primereact/card';
import { useParams } from "react-router-dom"
import StatsCard from '../components/stats/StatsCard';
import React, { useEffect, useState } from 'react';
import PlayerChart from '../components/PlayerChart';
import PlayerHistory from '../components/PlayerHistory';
import { SERVER_HOST } from '../settings';
import { Tooltip } from 'primereact/tooltip';
import { CountriesService } from '../service/CountriesService';
import { InputSwitch } from 'primereact/inputswitch';

const fetchFromDb = (userId) => {
    const url = `${SERVER_HOST}/users/new/${userId}`;
    const options = {
    };
    return fetch(url, options).then(data => data.json());
}

const fetchFromGeoGuessr = (userId) => {
    const url = `${SERVER_HOST}/users/live/${userId}`;
    const options = {
    };
    return fetch(url, options).then(data => data.json());
}

export default function Player() {

    const [player, setPlayer] = useState({});
    const [latestBatch, setLatestBatch] = useState('');
    const [checked, setChecked] = useState(false);
    const [liveStatsLoading, setLiveStatsLoading] = useState(false);

    useEffect(() => {
        const url = `${SERVER_HOST}/latestBatches`;
        fetch(url).then(data => data.json()).then((data) => {
            setLatestBatch(new Date(data?.overall)?.toLocaleString());
        })
    });

    const loadFromGeoGuessr = async (playerId) => {
        return fetchFromGeoGuessr(playerId).then(geoGuessrData => {
            setLiveStatsLoading(false);
            const convertUserDataToPlayer = (userData) => {
                console.log('userData', userData)
                return {
                    id: userData?.userInfo?.id,
                    nick: userData?.userInfo?.nick,
                    countryCode: userData?.userInfo?.countryCode,
                    countryName: CountriesService.getCountryName(userData?.userInfo?.countryCode),
                    avatar: userData?.userInfo?.pin?.url?.split(/[\/\.]/)[1],
                    fullBodyPath: userData?.userInfo?.fullBodyPin?.split(/[\/\.]/)[1],
                    batchDate: userData?.userInfo?.created

                }
            };
            // setPlayer(convertUserDataToPlayer(geoGuessrData));
            setPlayer({...geoGuessrData, countryName: CountriesService.getCountryName(geoGuessrData?.countryCode)});
            return;
        })
    }

    const loadUserData = (playerId) => {
        fetchFromDb(playerId).then(data => {
            setLiveStatsLoading(false);
            if (!isEmpty(data)) {
                setPlayer(data);
            } else {
                loadFromGeoGuessr(playerId);
            }
        });
    };

    const isEmpty = (obj) => {
        for (let i in obj) {
            return false;
        }
        return true;
    }

    const { playerId } = useParams();
    useEffect(() => {
        loadUserData(playerId);
    }, []);

    // const duelsMapping = {
    //     standardDuels: 'moving',
    //     noMoveDuels: 'no move',
    //     nmpzDuels: 'nmpz'
    // }
    const renderFlag = (countryCode) => {
        return (
            <img src={`../flags/${countryCode}.png`} style={{ width: '24px' }} />
        );
    }
    const textWithFlag = (text, countryCode) => {
        return (
            <span>
                {renderFlag(countryCode)}
                &nbsp;
                <span>{text}</span>
                &nbsp;
                {renderFlag(countryCode)}
            </span>
        );
    }
    const renderImage = (src) => {
        return (
            <img src={src} style={{ width: '24px' }} />
        );
    }
    const textWithImage = (text, src) => {
        return (
            <span>
                {renderImage(src)}
                &nbsp;
                <span>{text}</span>
                &nbsp;
                {renderImage(src)}
            </span>
        );
    }
    
    const renderRating = (stats, statName) => {
        if (!stats) {
            return '-';
        }
        if (stats.isLatestBatch === 0) {
            const id = Math.floor(Math.random()*1000); // TODO
            return (
                <div>
                    <Tooltip target={`.${statName}-${id}`} mouseTrack mouseTrackLeft={10} />
                    <i className={`${statName}-${id}`} data-pr-tooltip={`Currently not classified, last ranked on ${new Date(stats.batchDate).toLocaleDateString()}`}
                        data-pr-position="right"
                        data-pr-at="right+5 top"
                        data-pr-my="left center-2"
                        style={{ cursor: 'help' }}>{stats[statName]}*
                    </i>
                </div>
            );
        }
        return stats[statName];
    }
    const getFooterRating = (currentStats, statName) => {   
        if (!currentStats) {
            return [];
        }
        
        const renderGameMode = (gameMode) => {
            const labelText = {
                overall: 'Overall',
                moving: 'Moving',
                nomove: 'No move',
                nmpz: 'NMPZ'
            };
            return labelText[gameMode];
        }
        return ['moving', 'nomove', 'nmpz'].map(gameMode => ({
            top: renderRating(currentStats[gameMode], statName),
            bottom: renderGameMode(gameMode)
        }));
    }
    const rating = {
        header: {
            title: textWithImage('geoguessr', 'https://www.geoguessr.com/_next/static/media/favicon.bffdd9d3.png'),
            subtitle: 'rating'
        },
        body: {top: renderRating(player?.currentStats?.overall, 'rating')},
        footer: getFooterRating(player?.currentStats, 'rating'),
        liveStats: !liveStatsLoading && checked,
        loading: liveStatsLoading
    }
    const calcPercent = (pos, total) => {
        return Math.ceil(pos/total*100);
    }
    const renderPercentage = (percentage) => {
        if (!percentage || isNaN(percentage)) {
            return '';
        }
        if (percentage < 50) {
            return `Top ${percentage}%`;
        }
        return `Better than ${100-percentage}%`;
    };

    const currentStats = player?.currentStats;

    const position = {
        header: {
            title: textWithFlag('world', 'un'),
            subtitle: 'position'
        },
        body: {
            top: renderRating(player?.currentStats?.overall, 'position'),
            bottom: renderPercentage((calcPercent(currentStats?.overall?.position, currentStats?.overall?.worldTotalPlayers)||'-'))
        },
        footer: getFooterRating(player?.currentStats, 'position'),
        liveStats: !liveStatsLoading && checked,
        loading: liveStatsLoading
    }
    const country = {
        header: {
            title: textWithFlag(player.countryName, player.countryCode),
            subtitle: 'position'
        },
        body: {
            top: renderRating(player?.currentStats?.overall, 'countryPosition'),
            bottom: renderPercentage((calcPercent(currentStats?.overall?.countryPosition, currentStats?.overall?.countryTotalPlayers)||'-'))
        },
        footer: getFooterRating(player?.currentStats, 'countryPosition'),
        liveStats: !liveStatsLoading && checked,
        loading: liveStatsLoading
    }

    function fitText(container) {
        const textElement = container.querySelector("span");
        let fontSize = parseInt(window.getComputedStyle(textElement).fontSize, 10);
    
        while (textElement.scrollWidth > container.offsetWidth && fontSize > 10) {
          fontSize--;
          textElement.style.fontSize = `${fontSize}px`;
          Array.from(textElement.querySelectorAll('img')).map($el => $el.style.width = `${fontSize}px`)
        }
      }
    
      document.querySelectorAll(".header-title").forEach(fitText);
      setTimeout(() => {
          document.querySelectorAll(".header-title").forEach(fitText);
      }, 0);

    const title = (
        <span><img src={`https://www.geoguessr.com/images/resize:auto:300:300/gravity:ce/plain/pin/${player.fullBodyPath}.png`} style={{ position: 'absolute', 'marginLeft': '-14rem', height: '300px' }}/> <a href={`https://geoguessr.com/user/${player.id}`} target="_blank">{player.nick} {renderFlag(player.countryCode)}</a></span>
        );
    
    const onSwitchLiveRanking = (value) => {
        setLiveStatsLoading(true);
        setChecked(value);
        if (value) {
            loadFromGeoGuessr(playerId);
        } else {
            loadUserData(playerId);
        }
    }

    return (
        <div>
            <Card title={title} className="player">
                <div className="stats-container2 grid md:col-10 md:col-offset-1 col-12">
                    <div className="md:col-4 md:pd-0 pd-2">
                        <StatsCard stats={rating}></StatsCard>
                    </div>
                    <div className="md:col-4 md:pd-0 pd-2">
                        <StatsCard stats={position}></StatsCard>
                    </div>
                    <div className="md:col-4 md:pd-0 pd-2">
                        <StatsCard stats={country}></StatsCard>
                    </div>
                </div>
                <h3 class="text-align-center">Last ranking update: {latestBatch}</h3>
                <h3 class="switch-to-live-ranking">Switch to live ranking <InputSwitch checked={checked} onChange={(e) => onSwitchLiveRanking(e.value)} /></h3>
                
            </Card>
            <Card title="Player's history">
                <PlayerHistory geoGuessrProfile={player.currentStats ? null : player} playerId={playerId}/>
            </Card>
            <Card title="Rating over time" className={player.currentStats ? '' : 'hidden'}>
                <PlayerChart rankingData={null} datasetName='rating'></PlayerChart>
            </Card>
            <Card title="Global position over time" className={player.currentStats ? '' : 'hidden'}>
                <PlayerChart rankingData={null} datasetName='globalPosition' reverseScale={true} minValue={1}></PlayerChart>
            </Card>
            <Card title="Country position over time" className={player.currentStats ? '' : 'hidden'}>
                <PlayerChart rankingData={null} datasetName='countryPosition' reverseScale={true} minValue={1}></PlayerChart>
            </Card>
        </div>
    );
};